<template>
  <div class="homeContainer">
    <div class="content" :style="styleObject">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data(){
     return{
      styleObject: {
        height: ""
      },
     }
  },
  created(){   
    this.makeheight()
  },
  methods:{
      //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 84) {
      console.log(this.$store.state.currDbSource);
         
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
  }
}
</script>

<style lang="scss" scoped>
.homeContainer{
   width: 100%;
   height: 100%;
   .content{
      height: 100%;
   }  
}
</style>

